import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type {
  MultiCountryRoleConfig,
  InterviewItem,
  SubTypeConfig,
  ConcertoConfig
} from 'src/app/models/multi-country.model';
import { environment as ENV } from '../../environments/environment';
import type { OriginConfig } from '../models/origins.model';

@Injectable({
  providedIn: 'root'
})
export class MultiCountryService {
  private CONFIG_URL_V2 = `${ENV.gateway}/api/multicountry/v2/configuration`;
  private readonly http = inject(HttpClient);

  async getConfigByRole(role: string) {
    return new Promise<MultiCountryRoleConfig>((resolve, reject) => {
      const roleUrl = `${this.CONFIG_URL_V2}/backoffice/${role}/allowableActions`;
      return this.http.get<MultiCountryRoleConfig>(roleUrl, {}).subscribe({
        next: (response) => resolve(response),
        error: (err) => reject(`The following error has occurred: ${err}`)
      });
    });
  }

  getCountrySubTypes(): Promise<SubTypeConfig[]> {
    return new Promise<SubTypeConfig[]>((resolve, reject) => {
      const url = `${this.CONFIG_URL_V2}/backoffice/subTypes`;
      return this.http.get<SubTypeConfig[]>(url, {}).subscribe({
        next: (response) => resolve(response),
        error: (err) => reject(`The following error has occurred: ${err}`)
      });
    });
  }

  getCountryOrigins() {
    return new Promise<OriginConfig>((resolve, reject) => {
      const url = `${this.CONFIG_URL_V2}/backoffice/origins`;
      return this.http.get<OriginConfig>(url, {}).subscribe({
        next: (response) => resolve(response),
        error: (err) => reject(`The following error has occurred: ${err}`)
      });
    });
  }

  getConcertoInterviewReasons() {
    return new Promise<InterviewItem[]>((resolve, reject) => {
      const url = `${this.CONFIG_URL_V2}/prospects/concerto`;
      return this.http.get<ConcertoConfig>(url, {}).subscribe({
        next: ({ interview }) => resolve(interview),
        error: (err) => reject(`The following error has occurred: ${err}`)
      });
    });
  }

  getAvailableLanguages() {
    return new Promise<string[]>((resolve, reject) => {
      const url = `${this.CONFIG_URL_V2}/backoffice/availableLanguages`;
      return this.http.get<string[]>(url, {}).subscribe({
        next: (response) => resolve(response),
        error: (err) => reject(`The following error has occurred: ${err}`)
      });
    });
  }
}
